import { ArticleData } from 'model/Article';

export type TagValues = {
  firstTag?: string;
  secondTag?: string;
};

export type ArticleHeroProps = {
  article: ArticleData;
  anchorId?: string;
  tagValues: TagValues;
};
